import shopifyEmpireGenericDefaults from '../shopify-empire-generic/config.js';

const isProductPage = window.Convermax.Shopify?.getPageType() === 'product';

const wheelsFields = shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;
const tiresFields = shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;

shopifyEmpireGenericDefaults.Widgets.map((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets' || w.name === 'FacetDialog') {
    if (w.ignoreFields) {
      w.ignoreFields.push('wheel_aggressive');
    } else {
      w.ignoreFields = ['wheel_aggressive'];
    }
  }
  return w;
});

window.Convermax.onInitQuickView = (item, productNode) => {
  if (item.category && (item.category.includes('Wheels') || item.category.includes('Tires'))) {
    const quantityInput = productNode.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = 4;
    }

    const priceSection = productNode.querySelector('.price.product__price');
    if (priceSection) {
      const priceElement = priceSection.querySelector('.price__current');
      if (priceElement) {
        priceSection.querySelector('.price__current--set')?.remove();
        const setPriceNode = document.createElement('div');

        setPriceNode.className = 'price__current--set';
        setPriceNode.textContent = `Set of 4: ${item.price * 4}`;
        priceElement.insertAdjacentElement('afterend', setPriceNode);
      }
    }
  }
};

function verifyLinkedOptions(vehicle) {
  const options = getLinkedOptions();
  if (!options?.length || !vehicle || !Object.keys(vehicle).length) {
    return;
  }

  options
    .map((option) => option.dataset.productId)
    .filter(Boolean)
    .forEach((productId) => {
      window.Convermax.verifyFitmentAsync(productId, vehicle)
        .then((fits) => {
          if (fits !== 'yes') {
            disableLinkedOption(options, productId);
          }
        })
        .catch(() => {
          disableLinkedOption(options, productId);
        });
    });
}

function getLinkedOptions() {
  const container = window.document.querySelector('linked-products');
  if (!container) {
    return;
  }

  return [...container.querySelectorAll('select option')];
}

function enableLinkedOptions() {
  const options = getLinkedOptions();
  options?.forEach((option) => {
    option.disabled = false;
  });
}

function disableLinkedOption(options, productId) {
  const option = options.find((option) => option.dataset.productId === productId);
  if (option) {
    option.disabled = true;
  }
}

async function InitFunc() {
  shopifyEmpireGenericDefaults.InitFunc?.();

  if (isProductPage) {
    window.document.addEventListener('linked-products-loaded', () => {
      verifyLinkedOptions(window.Convermax.getVehicle());
    });
  }
}

export default {
  includes: ['shopify-empire-generic'],
  ...shopifyEmpireGenericDefaults,
  InitFunc,
  fitmentSearch: {
    ...shopifyEmpireGenericDefaults.fitmentSearch,
    onVehicleSelected: (vehicle) => {
      shopifyEmpireGenericDefaults.fitmentSearch.onVehicleSelected?.(vehicle);

      if (isProductPage) {
        verifyLinkedOptions(vehicle);
      }
    },
    onVehicleDiscarded: () => {
      shopifyEmpireGenericDefaults.fitmentSearch.onVehicleDiscarded?.();

      if (isProductPage) {
        enableLinkedOptions();
      }
    },
  },
  autocomplete: {
    requestDefaults: {
      extra: { isAutoCompleteRequest: true },
    },
  },
  facets: {
    ...shopifyEmpireGenericDefaults.facets,
    toggleFacet: [{ fields: ['wheel_aggressive'], term: 'Yes', initToggled: true }],
  },
  Widgets: [
    ...shopifyEmpireGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'HeaderVehicleWidget',
          'FacetBarWheels',
          'FacetBarTires',
          'HomeVehicleWidget_tab',
          'TirePanel_tab',
          'WheelPanel_tab',
        ].includes(w.name),
    ),
    {
      ...shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'HeaderVehicleWidget'),
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysColumnLayout: true,
      isAlwaysActive: true,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields,
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields,
      minFacetCount: 2,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter', 'wheel_aggressive'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-home-ymm',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-tire',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: tiresFields,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-wheel',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: wheelsFields,
    },
  ],
};
